"use client";

import {
	type Dispatch,
	type ReactNode,
	type SetStateAction,
	createContext,
	useContext,
} from "react";
import type { ResolvedIntlConfig } from "react-intl";
import type { Money } from "../../../../apps/frontend/graphql";
import type { ApiData } from "../components/renderer/data";
import type { CabinetState } from "./StoreContext";

export interface ConfigContextValue {
	data?: ApiData;
	mode: "editCartItem" | "editProjectItem" | "add" | "view" | "expandedView";
	dialog?: true;
	quantity?: number;
	orderData?: string;
	material: string | null;
	thickness: number | null;
	messages?: ResolvedIntlConfig["messages"];
	settings?: Map<string, string>;
	routes?: Map<string, string>;
	lang: string;
	customer?: { name: string; email: string };
	wishlistButton?: ReactNode;
	calculatePrice?: (data: string) => Promise<"error" | "calculating" | Money>;
	onAddToCart?: (orderData: string, quantity: number) => Promise<void> | void;
	onAddSampleToCart?: (sampleProductId: string) => Promise<void> | void;
	onSave?: (input: onSaveInputType) => Promise<OnSaveReturnType | undefined>;
	onStoreChange?: (state: CabinetState, api?: ApiData) => unknown;
	openSampleDialog?: boolean;
	setOpenSampleDialog?: Dispatch<SetStateAction<boolean>>;
}

type onSaveInputType = {
	reference?: string;
	name?: string;
	email: string;
	data: string;
	price?: Money;
};

export type OnSaveReturnType = {
	data?: { url: string; code: string };
	serverError?: string;
	validationErrors?: unknown;
};

export const ConfigContext = createContext<ConfigContextValue>({} as ConfigContextValue);

export function useConfig() {
	const context = useContext(ConfigContext);

	if (context === null)
		throw new Error("ConfigContext of tosize-furniture-configurator is not available");

	return context;
}
